"use client";

import { useContext, useEffect, useState } from "react";

import { analyticsContext } from "../lib/analyticsContext";
import type { AnalyticsEvent } from "../types/analyticsEvent.types";
import { HallowAnalyticsEvent } from "../types/enums/hallowAnalyticsEvent.enum";

export type UseViewedScreenProps = {
  event?: HallowAnalyticsEvent;
  screen: string;
  properties?: AnalyticsEvent["properties"];
  isReady?: boolean;
};

export const useViewedScreen = ({
  event = HallowAnalyticsEvent.ViewedScreen,
  screen,
  properties = {},
  isReady = true,
}: UseViewedScreenProps) => {
  const [isMounted, setIsMounted] = useState(false);
  const { track } = useContext(analyticsContext);

  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);

  useEffect(() => {
    if (isMounted && isReady)
      track({
        event,
        properties: {
          screen_name: screen,
          ...properties,
        },
      });
  }, [isMounted, isReady]);
};
